export default {
  // 保存规格单价
  insertAllYxSpecPrice: '/ygsjzs/yxSpecPrice/insertAllYxSpecPrice',
  // 查询规格单价详情
  selectYxSpecPriceById: '/ygsjzs/yxSpecPrice/selectYxSpecPriceById',
  // 查询规格单价列表
  selectYxSpecPriceByList: '/ygsjzs/yxSpecPrice/selectYxSpecPriceByList'

}
